import { useIsRoute } from '@/hooks/useIsRoute'
import { ROUTES } from '@/lib/routes'

export function useIsCompanyProfilePage() {
  const isRoute = useIsRoute()

  return isRoute(ROUTES._companyProfile)
}
